import React from "react";
import { Col, Row } from "reactstrap";
import { T } from "../traks";
import { BinaryToggle } from "./BinaryToggle";

export const GameDiversificationSection = ({ handleDiversificationChange, simple_checkbox_change, state}) => {
    return (
        <React.Fragment>
            <span className="txt-15px"><T>Set diversification rules to make the game more realistic and promote balanced investment across stocks, bonds, commodities, and crypto.</T></span>

            <Row className="justify-content-center">
                <Col md="12" className="new_game_premium px-md-4 pt-4">
                    <img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" />
                        <span className="ad_120_bold pl-2"><T>Diversification</T></span>
                            <p>
                                <small><T>Enforce diversification across stocks, bonds, and commodities. Non-compliance will be shown on the leaderboard.</T></small><br/>
                            </p>
                    <div className="text-left">
                            <BinaryToggle 
                            name={"diversification_enabled"}
                            checked={state.diversification_enabled}
                            onChange={simple_checkbox_change}
                            labels={[<T>Activate</T>, <T>Deactivate</T>]}
                            />
                    </div>
                </Col>
            </Row>

            {state.diversification_enabled && (
            <Row className="justify-content-center">
                <Col md="12" className="px-md-4 pt-4">
                <img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" />
                <span className="ad_120_bold pl-2"><T>Diversification settings</T></span>
                <p>
                    <small><T>Set minimum percentages for each asset class. Players must stay within limits to meet diversification requirements.</T></small>
                </p>
                
                <Row className="pt-3">
                    <Col md="6">
                        <span className="ad_120_bold pl-2"><T>Stocks (%)</T></span>
                        <div className="ad_newgame_formgroup pt-2">
                            <div className="input-group">
                                <input
                                    type="number"
                                    name="diversification_stocks"
                                    className="ad_input ad_3px_radius ad_height_50px w-75 pl-3"
                                    min="0"
                                    max="100"
                                    step="1"
                                    value={state.diversification.stocks || 20}
                                    onChange={(e) => handleDiversificationChange('stocks', e.target.value)}
                                />
                            </div>
                        </div>
                    </Col>

                    <Col md="6">
                        <span className="ad_120_bold pl-2"><T>Bonds/ETFs/Funds (%)</T></span>
                        <div className="ad_newgame_formgroup pt-2">
                            <div className="input-group">
                                <input
                                    type="number"
                                    name="diversification_bonds"
                                    className="ad_input ad_3px_radius ad_height_50px w-75 pl-3"
                                    min="0"
                                    max="100"
                                    step="1"
                                    value={state.diversification.bonds || 20}
                                    onChange={(e) => handleDiversificationChange('bonds', e.target.value)}
                                />
                            </div>
                        </div>
                    </Col>

                    <Col md="6" className="pt-4">
                        <span className="ad_120_bold pl-2"><T>Commodities (%)</T></span>
                        <div className="ad_newgame_formgroup pt-2">
                            <div className="input-group">
                            <input
                                type="number"
                                name="diversification_commodities"
                                className="ad_input ad_3px_radius ad_height_50px w-75 pl-3"
                                min="0"
                                max="100"
                                step="1"
                                value={state.diversification.commodities || 20}
                                onChange={(e) => handleDiversificationChange('commodities', e.target.value)}
                            />
                            </div>
                        </div>
                    </Col>

                    <Col md="6" className="pt-4">
                        <span className="ad_120_bold pl-2"><T>Crypto (%)</T></span>
                        <div className="ad_newgame_formgroup pt-2">
                            <div className="input-group">
                                <input
                                    type="number"
                                    name="diversification_crypto"
                                    className="ad_input ad_3px_radius ad_height_50px w-75 pl-3"
                                    min="0"
                                    max="100"
                                    step="1"
                                    value={state.diversification.crypt || 0}
                                    onChange={(e) => handleDiversificationChange('crypto', e.target.value)}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
            </Row>
            )}

        </React.Fragment>
    )
};


// WEBPACK FOOTER //
// ./src/c/GameDiversificationSection.js